
export default function EmtyDiv2 (){
      return <div className=" w-16         h-c72 bg-gray-EA   rounded-book-icon book-shadow   "></div>
      
}